module.exports = __webpack_public_path__ + "static/media/12.2a0f21c3.jpg";